import { render, staticRenderFns } from "./CalendarPanel.vue?vue&type=template&id=fde15b82&"
import script from "./CalendarPanel.vue?vue&type=script&lang=js&"
export * from "./CalendarPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports